export default () => {
    return (value) => {
        return Date.parse(value);
    }
}